const getLocalStorageValue = (authorizedUserId, key, filtersType) => {
  const storagedUserData = JSON.parse(localStorage.getItem(authorizedUserId));
  const filters = storagedUserData?.[filtersType];
  return filters?.[key] // если в localStorage еще ничего не было сохранено, то в данное поле стейта будет записан null.
}

export default getLocalStorageValue;